// extracted by mini-css-extract-plugin
export var formNewsletter = "styles-module--formNewsletter--3h_lD";
export var formNewsletterTitle = "styles-module--formNewsletterTitle--2Z2-b";